import { render, staticRenderFns } from "./MpsTextarea.vue?vue&type=template&id=40a5e5c8&scoped=true"
import script from "./MpsTextarea.vue?vue&type=script&lang=js"
export * from "./MpsTextarea.vue?vue&type=script&lang=js"
import style0 from "./MpsTextarea.vue?vue&type=style&index=0&id=40a5e5c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a5e5c8",
  null
  
)

export default component.exports